import * as ActionTypes from 'state/actions/types'

export const openingEventsChangeField = (field, value) => {
  return {
    type: ActionTypes.OPENING_EVENTS_CHANGE_FIELD,
    field,
    value
  }
}

export const openingEventsChangeDateRange = (startDate, endDate) => {
  return {
    type: ActionTypes.OPENING_EVENTS_CHANGE_CUSTOM_DATE_RANGE,
    startDate,
    endDate
  }
}

export const openingEventsMoveCustomDateRange = operation => {
  return {
    type: ActionTypes.OPENING_EVENTS_MOVE_CUSTOM_DATE_RANGE,
    operation
  }
}
